import { isMyBiz, isMyPartner, isPartnerMMT } from "@tm/insurance/utils";
import { FunnelVars, PageName } from "./IAnalytics";

const LOB_NAME_TM_INS = isPartnerMMT()
  ? "desktop tripmoney insurance"
  : "tripmoney insurance";

const LOB_NAME_PS_INS = isPartnerMMT()
  ? "desktop ps tripmoney insurance"
  : "ps tripmoney insurance";

const FUNNEL_SITE_SECTION = isPartnerMMT()
  ? "desktop tripmoney insurance Funnel"
  : "tripmoney insurance Funnel";

const LANDING_SITE_SECTION = "landing";

export const LOB_NAME_MYPARTNER = "desktop tripmoney insurance mypartner";

const PAGE_NAMES_MAP_MMT = {
  COMMON_LANDING: "desktop:common_landing:mmt_insurance:homepage",
  COMMON_LANDING_RETAIL: "desktop:common_landing:mmt_insurance:homepage_retail",
  LANDING: "desktop:landing:mmt_insurance:homepage",
  LANDING_RETAIL: "desktop:landing:mmt_insurance:homepage_retail",
  LISTING: "desktop:funnel:mmt_insurance:listing",
  REVIEW: "desktop:funnel:mmt_insurance:review",
  PAYMENT: "desktop:funnel:mmt_insurance:payment",
  THANK_YOU_POLICY: "desktop:funnel:mmt_insurance:TY_policy",
  THANK_YOU_PASSPORT: "desktop:funnel:mmt_insurance:TY_passport",
  ADD_PASSPORT: "desktop:funnel:mmt_insurance:add_passport",
  ORDER_SUMMARY: "desktop:post_Sales:mmt_insurance:order_summary",
  ORDER_DETAILS: "desktop:post_Sales:mmt_insurance:order_details",
  ORDER_DETAILS_V2: "desktop:post_Sales:mmt_insurance:order_details_v2",
  CLAIMS_INSURANCE: "desktop:post_Sales:mmt_insurance:claims_insurance",
};

const PAGE_NAMES_MAP_GI = {
  COMMON_LANDING: "common_landing:tripmoney insurance:homepage",
  COMMON_LANDING_RETAIL: "common_landing:tripmoney insurance:homepage_retail",
  LANDING: "landing:tripmoney insurance:landing",
  LANDING_RETAIL: "landing:tripmoney insurance:homepage_retail",
  LISTING: "funnel:tripmoney insurance:listing",
  REVIEW: "funnel:tripmoney insurance:review",
  PAYMENT: "funnel:tripmoney insurance:payment",
  THANK_YOU_POLICY: "funnel:tripmoney insurance:thankyoupolicy",
  THANK_YOU_PASSPORT: "funnel:tripmoney insurance:thankyoupassport",
  ADD_PASSPORT: "funnel:tripmoney insurance:addpassport",
  ORDER_SUMMARY: "post sales:ps_tripmoney insurance:order_summary",
  ORDER_DETAILS: "post sales:ps_tripmoney insurance:order_details",
  ORDER_DETAILS_V2: "post sales:ps_tripmoney insurance:order_details_v2",
  CLAIMS_INSURANCE: "post sales:ps_tripmoney insurance:claims_insurance",
};

const PAGE_NAMES_MAP =
  isPartnerMMT() || isMyPartner() || isMyBiz()
    ? PAGE_NAMES_MAP_MMT
    : PAGE_NAMES_MAP_GI;

export const pageNameCategoryMap: Record<PageName, FunnelVars> = {
  COMMON_LANDING: {
    pageName: PAGE_NAMES_MAP["COMMON_LANDING"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION,
  },
  COMMON_LANDING_RETAIL: {
    pageName: PAGE_NAMES_MAP["COMMON_LANDING_RETAIL"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION,
  },
  LANDING: {
    pageName: PAGE_NAMES_MAP["LANDING"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION,
  },
  LANDING_RETAIL: {
    pageName: PAGE_NAMES_MAP["LANDING_RETAIL"],
    lob: LOB_NAME_TM_INS,
    siteSection: LANDING_SITE_SECTION,
  },
  LISTING: {
    pageName: PAGE_NAMES_MAP["LISTING"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION,
  },
  REVIEW: {
    pageName: PAGE_NAMES_MAP["REVIEW"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION,
  },
  PAYMENT: {
    pageName: PAGE_NAMES_MAP["PAYMENT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION,
  },
  THANK_YOU_POLICY: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_POLICY"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION,
  },
  THANK_YOU_PASSPORT: {
    pageName: PAGE_NAMES_MAP["THANK_YOU_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION,
  },
  ADD_PASSPORT: {
    pageName: PAGE_NAMES_MAP["ADD_PASSPORT"],
    lob: LOB_NAME_TM_INS,
    siteSection: FUNNEL_SITE_SECTION,
  },
  ORDER_DETAILS: {
    pageName: PAGE_NAMES_MAP["ORDER_DETAILS"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA",
  },
  ORDER_DETAILS_V2: {
    pageName: PAGE_NAMES_MAP["ORDER_DETAILS_V2"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA",
  },
  CLAIMS_INSURANCE: {
    pageName: PAGE_NAMES_MAP["CLAIMS_INSURANCE"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA",
  },
  ORDER_SUMMARY: {
    pageName: PAGE_NAMES_MAP["ORDER_SUMMARY"],
    lob: LOB_NAME_PS_INS,
    siteSection: "NA",
  },
};
